import $ from 'jquery'

export default function initImageUpload(): void {
	function generateFilePreview(previewId: string, input: HTMLInputElement): void {
		if (input.files && input.files[0]) {
			const reader = new FileReader()

			reader.onload = function (data: ProgressEvent<FileReader>) {
				const result = data.target && (data.target as FileReader).result

				$(previewId).attr('src', result as string)
			}
			reader.readAsDataURL(input.files[0])
		}
	}

	$('#upload_image').on('click', function (event) {
		event.preventDefault()
		$('#files').click()
		$('#upload_image').blur()
	})

	$('#files').on('change', function (this: HTMLInputElement) {
		generateFilePreview('#logo_preview', this)
	})
}